import { FC, HTMLAttributes, useContext } from 'react'
import classNames from 'classnames'
import { InternalContext } from '../contexts/InternalContext'
import './ControlsVolumeValue.scss'

export const ControlsVolumeValue: FC<HTMLAttributes<HTMLDivElement>> = ({ className, children, ...attrs }) => {
  const {
    audioPlayer: { volume },
  } = useContext(InternalContext)

  return (
    <div className={classNames('ControlsVolumeValue', className)} {...attrs}>
      {Math.floor(volume * 100)}%
    </div>
  )
}
